export enum EMain {
  EVENTPLANNER_TITLE = 'HiQs Eventkalender',
}
